import {Component, OnInit} from '@angular/core';
import {PortalStateService} from './core/services/portal-state.service';
import {version} from '../version';
import {IconsService} from './core/services/icons.service';
import {Message} from 'src/portaljs/models/message';
import {ConsoleLogger} from './core/shared/console-logger';
@Component({
    selector: 'fss-portal-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private iconsService: IconsService,
              private pss: PortalStateService /* PortalStateService needs to be initialized immediately */) {
  }

  public ngOnInit(): void {
    Message.LIB_VERSION = undefined; // portal does not send version...
    ConsoleLogger.info('Build info: ' + JSON.stringify(version));
    this.iconsService.registerIcons();
  }

  public skipToContent(){
    const element: any = document.querySelector('[role="main"]');
    if(element){
      element.setAttribute('tabindex', '-1');
      element.focus();
      this.pss.sendSkipToContentAppAction();
    }
  }
}
